import React from "react";
import { Link } from "react-router-dom";
import { usePlans } from "../../hooks/usePlans";
import PlanCard from "../PlanCard";

export default function PricingSection() {
  const { plans, loading, error } = usePlans();

  return (
    <section id="pricing" className="saas-lp-section">
      <div className="saas-lp-inner">
        <div className="saas-lp-section__header">
          <p className="saas-lp-label">Pricing</p>
          <h2>Plans that scale with you</h2>
          <p>Start with a free trial and upgrade as your team and operations grow.</p>
        </div>

        {loading && <p className="saas-lp-center-text">Loading plans…</p>}

        {error && (
          <p className="saas-lp-notice">{error}</p>
        )}

        {!loading && plans.length > 0 && (
          <div className="saas-lp-grid saas-lp-grid--3">
            {plans.map((plan, i) => (
              <PlanCard key={plan.id || plan.slug} plan={plan} highlighted={i === 1} />
            ))}
          </div>
        )}

        <p className="saas-lp-center-text saas-lp-pricing__link">
          <Link to="/compare">View full plan comparison →</Link>
        </p>
      </div>
    </section>
  );
}
